import React, { SVGProps } from 'react';

function UserGroup(props: SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill, ...rest } = props;
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g clipPath="url(#clip0)">
        <path
          d="M4.8125 8.5625C4.8125 9.47418 5.17466 10.3485 5.81932 10.9932C6.46398 11.6378 7.33832 12 8.25 12C9.16168 12 10.036 11.6378 10.6807 10.9932C11.3253 10.3485 11.6875 9.47418 11.6875 8.5625C11.6875 7.65082 11.3253 6.77648 10.6807 6.13182C10.036 5.48716 9.16168 5.125 8.25 5.125C7.33832 5.125 6.46398 5.48716 5.81932 6.13182C5.17466 6.77648 4.8125 7.65082 4.8125 8.5625V8.5625Z"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M2.625 18.875C2.625 17.3832 3.21763 15.9524 4.27252 14.8975C5.32742 13.8426 6.75816 13.25 8.25 13.25C9.74184 13.25 11.1726 13.8426 12.2275 14.8975C13.2824 15.9524 13.875 17.3832 13.875 18.875"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M13.96 10.4375C13.96 11.1834 14.2563 11.8988 14.7837 12.4262C15.3112 12.9537 16.0265 13.25 16.7725 13.25C17.5184 13.25 18.2338 12.9537 18.7612 12.4262C19.2886 11.8988 19.585 11.1834 19.585 10.4375C19.585 9.69158 19.2886 8.97621 18.7612 8.44876C18.2338 7.92132 17.5184 7.625 16.7725 7.625C16.0265 7.625 15.3112 7.92132 14.7837 8.44876C14.2563 8.97621 13.96 9.69158 13.96 10.4375V10.4375Z"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M15.1775 14.5567C15.8734 14.3002 16.621 14.2156 17.3566 14.3101C18.0922 14.4046 18.7941 14.6753 19.4026 15.0993C20.0111 15.5233 20.5082 16.088 20.8516 16.7454C21.195 17.4028 21.3746 18.1334 21.375 18.875"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect fill="white" height="20" transform="translate(2 2)" width="20" />
        </clipPath>
      </defs>
    </svg>
  );
}

UserGroup.displayName = 'UserGroup';

export default UserGroup;
